import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const debouncedUpdate = debounce((newValue: T) => {
      setDebouncedValue(newValue);
    }, delay);

    debouncedUpdate(value);

    // Cleanup debounce on unmount or value change
    return () => {
      debouncedUpdate.cancel();
    };
  }, [value, delay]);

  return debouncedValue;
};
